export default {
  bannerModel: {
    confirmBannerChanges: 'Confirm banner changes',
    desc1:
      'Caution! If you change the banner model, <1>your consent statistics (i.e., consent ratio graphs) will be reset.</1> However, your past consent record will not be affected. Please ensure your change before publishing.',
    desc2: 'This action cannot be undone.',
  },
}
